export enum CategoryLevelType {
  ROOT = '0',
  FIRST_LEVEL = '1',
  ALL = '-1',
}

export const DEFAULT_CATEGORY_LEVEL: CategoryLevelType = CategoryLevelType.ROOT;
